import { render, staticRenderFns } from "./SequenceResult.vue?vue&type=template&id=1b9c36e5&"
import script from "./SequenceResult.vue?vue&type=script&lang=js&"
export * from "./SequenceResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports